;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useEffect, useState } from 'react';

export default function useDetectTouch() {
    const [isTouch, setIsTouch] = useState(null);

    useEffect(() => {
        const handleSetIsTouch = () => {
            setIsTouch(
                window.matchMedia('(hover: none) and (pointer: coarse)').matches
            );
        };

        handleSetIsTouch();

        window.addEventListener('resize', handleSetIsTouch);

        return () => {
            window.removeEventListener('resize', handleSetIsTouch);
        };
    }, []);

    return isTouch;
}
